import {
  JOURNEY_PHASES,
  JOURNEY_QUEUE_DEMO,
} from "../../data/landingContent";
import Reveal from "./Reveal";

const queue = JOURNEY_QUEUE_DEMO;
const caseSheet = queue.caseSheet;

function JourneyDots({ colors }) {
  if (!colors?.length) return <span className="journey-queue-dash">—</span>;
  return (
    <div className="journey-queue-dots" aria-hidden="true">
      {colors.map((c, i) => (
        <span key={i} style={{ background: c }} />
      ))}
    </div>
  );
}

export default function PatientJourney() {
  return (
    <section id="journey" className="journey-section journey-dark" aria-labelledby="journey-heading">
      <div className="wrap">
        <Reveal>
          <span className="kicker">Patient journey</span>
          <h2 className="section-title" id="journey-heading">
            Built for the Entire <b>Patient Journey</b>
          </h2>
          <p className="section-lede journey-lede-accent">
            Every input. Every output. <b>One chart.</b>
          </p>
          <p className="section-lede">
            Customised to how your clinic works — from first call to follow-up, Lab, Radiology,
            Dietitian, Medicine, Physiotherapy, and Billing stay on the same patient record.
          </p>
        </Reveal>

        <Reveal className="journey-rail" aria-label="Visit flow">
          <div className="journey-rail-track" aria-hidden="true" />
          <div className="journey-rail-steps">
            {JOURNEY_PHASES.map((step) => (
              <div className="journey-rail-step" key={step.n}>
                <span className="journey-rail-node">{step.n}</span>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="journey-showcase">
          <div className="journey-frame">
            <div className="journey-frame-chrome">
              <span className="journey-chrome-dot" />
              <span className="journey-chrome-dot" />
              <span className="journey-chrome-dot" />
              <span className="journey-chrome-url">{queue.url}</span>
            </div>

            <div className="journey-app">
              <div className="journey-table-wrap">
                <table className="journey-queue-table">
                  <thead>
                    <tr>
                      <th>Registered</th>
                      <th>Token</th>
                      <th>Name</th>
                      <th>Visit</th>
                      <th>Case / Diagnosis</th>
                      <th>Journey</th>
                      <th>Status</th>
                      <th aria-label="Actions" />
                    </tr>
                  </thead>
                  <tbody>
                    {queue.active.map((row) => (
                      <tr
                        key={row.uhid}
                        className={
                          row.focus || row.uhid === caseSheet.uhid ? "is-focused" : undefined
                        }
                      >
                        <td>{row.time}</td>
                        <td>
                          <span className={`journey-token ${row.tokenMuted ? "muted" : ""}`}>
                            {row.token}
                          </span>
                        </td>
                        <td className="journey-name-cell">
                          <span className="journey-patient-name">{row.name}</span>{" "}
                          <span className="journey-patient-age">({row.age})</span>
                          <span className="journey-patient-uhid">{row.uhid}</span>
                        </td>
                        <td>
                          <span className="journey-visit-badge">{row.visit}</span>
                        </td>
                        <td className="journey-diagnosis-cell">{row.diagnosis}</td>
                        <td className="journey-journey-cell"><JourneyDots colors={row.journey} /></td>
                        <td className="journey-status-cell">
                          <span className={`journey-status ${row.statusClass}`}>{row.status}</span>
                        </td>
                        <td className="journey-actions-cell">
                          <div className="journey-row-actions" aria-hidden="true">
                            <span>▶</span>
                            <span>✓</span>
                            <span>⋯</span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="journey-queue-divider">COMPLETED</div>

              <div className="journey-table-wrap">
                <table className="journey-queue-table journey-queue-table-completed">
                  <tbody>
                    {queue.completed.map((row) => (
                      <tr key={`${row.name}-${row.time}`}>
                        <td className="journey-time-cell">{row.time}</td>
                        <td>
                          <span className="journey-token">{row.token}</span>
                        </td>
                        <td className="journey-name-cell">
                          <span className="journey-patient-name">{row.name}</span>{" "}
                          <span className="journey-patient-age">({row.age})</span>
                          {row.uhid ? (
                            <span className="journey-patient-uhid">{row.uhid}</span>
                          ) : null}
                        </td>
                        <td>
                          <span className="journey-visit-badge">{row.visit}</span>
                        </td>
                        <td className="journey-diagnosis-cell">{row.diagnosis}</td>
                        <td className="journey-journey-cell">
                          <span className="journey-queue-dash">—</span>
                        </td>
                        <td className="journey-status-cell">
                          <span className={`journey-status ${row.statusClass}`}>{row.status}</span>
                        </td>
                        <td className="journey-actions-cell" aria-hidden="true" />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="journey-tooltip" role="note">{caseSheet.tooltip}</div>
          </div>

          <div className="journey-float-card" aria-label="Case sheet preview">
            <div className="journey-float-head">
              <span className="journey-float-uhid">{caseSheet.uhid}</span>
              <b>{caseSheet.name}</b>
              <span className="journey-float-meta">{caseSheet.meta}</span>
            </div>
            <div className="journey-float-tabs">
              {caseSheet.tabs.map((tab) => (
                <span
                  key={tab.label}
                  className={`journey-float-tab ${tab.active ? "active" : ""}`}
                >
                  {tab.label}
                  {tab.dot ? <i className={tab.dot} aria-hidden="true" /> : null}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
